import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getAdminWorkCalendarFilesDataForProjectInTimeFrame = async (
  projectId,
  fromDate,
  toDate,
  activeEmployerInfo
) => {
  const apiPath = `workflow/admin-request/files/${projectId}/${fromDate}/${toDate}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
